<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="加工组织" :help="null">
              <a-select show-search option-filter-prop="children" v-decorator="['organizationCode', { rules: [{ required: true }], initialValue: inventOrg.length > 0 && inventOrg[0].realValue }]" option-label-prop="label">
                <a-select-option v-for="(item) in inventOrg" :key="item.realValue" :value="item.realValue" :label="item.label">
                  {{ item.realValue }}-{{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="SPU" :help="null">
              <global-select
                v-decorator="['spuItemCode', { rules: [{ required: true }] }]"
                selectType="selectSearch"
                requestApi="/mdm/mdmItemOrganizationItem/findSpuCodeList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ organizationCode: organizationCodeOrigin }"
                searchParam="spuCode"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="SKU">
              <global-select
                v-decorator="['skuItemId']"
                selectType="selectSearch"
                requestApi="/mdm/mdmItemOrganizationItem/findList"
                :selectItem="{ value: 'id', label: 'itemCode' }"
                :setParams="{ organizationCode: organizationCodeOrigin }"
                searchParam="itemCodeFrom"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="替代项">
              <a-select v-decorator="['alternateId']">
                <a-select-option v-for="(item) in tdxList" :key="item.alternateDesignatorCode">{{ item.alternateDesignatorDesc }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a-button @click="$refs.createModal.show('add')" type="primary" class="ml8" v-hasPermi="['bom:bomRoutingHeader:add']">新建</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show('edit', tableData)" type="primary" :disabled="tableLoading" v-hasPermi="['bom:bomRoutingHeader:edit']">编辑</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['bom:bomRoutingHeader:import']">导入</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['bom:bomRoutingHeader:export']">导出</a-button>
      <a-button @click="importTemplate" v-hasPermi="['bom:bomRoutingHeader:template']">下载模板</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="tableList"
          :pagination="false"
        >
        </a-table>
        <create-form
          ref="createModal"
          :inventOrg="inventOrg"
          :tdxYesList="tdxYesList"
          @handle-success="handleOk"
        />
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { listRoutingHeaderDetail, bomAlternateDesignators } from '@/api/mes/basedata/productProcess'
import CreateForm from './components/CreateForm'
import Cookies from 'js-cookie';
export default {
  name: 'ProductProcess',
  components: {
    CreateForm
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomRoutingHeader/import'
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      tableData: null,
      tableLoading: false,
      // 表格字段
      columns: [
        {
          title: '工序号',
          dataIndex: 'operationSeqNum',
          align: 'center'
        },
        {
          title: '工序编码',
          dataIndex: 'operationCode',
          align: 'center'
        },
        {
          title: '工序说明',
          dataIndex: 'operationDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工序类型',
          dataIndex: 'operationType',
          align: 'center'
        },
        {
          title: '工作时间(时/天)',
          dataIndex: 'workingHours',
          width: 140,
          align: 'center'
        },
        {
          title: '配置人数',
          dataIndex: 'personnelAllocation',
          align: 'center'
        },
        {
          title: '产能类型',
          dataIndex: 'capacityType',
          align: 'center'
        },
        {
          title: '产能效率(套/分钟)',
          dataIndex: 'efficiency',
          width: 150,
          align: 'center'
        },
        {
          title: '产能(套/时)',
          dataIndex: 'unitCapacity',
          align: 'center'
        }
      ],
      tdxList: [], // 替代项
      tdxYesList: []
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getTdxList()
  },
  methods: {
    // 替代项-下拉框数据
    getTdxList () {
      bomAlternateDesignators().then(res => {
        if (res && res.length > 0) {
          const arr = []
          res.forEach(element => {
            if (element.alternateStatus === "Y") {
              arr.push(element)
            }
          });
          this.tdxYesList = arr
          this.tdxList = res
        }
      })
    },
    /** 查询列表 */
    getList () {
      this.tableLoading = true
      const params = this.form.getFieldsValue()
      params.isStandardRoutingFlag = "N"
      listRoutingHeaderDetail(params).then(res => {
        this.tableData = res.data || null
        this.tableList = res.data && res.data.bomRoutingLineDTOList
        this.tableLoading = false
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.handleQuery()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      if (!this.form.getFieldsValue().organizationCode) {
        this.$message.warning('加工组织不能为空')
        return;
      }
      if (!this.form.getFieldsValue().spuItemCode) {
        this.$message.warning('SPU不能为空')
        return;
      }
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('bom/bomRoutingHeader/template', {},
      `产品工艺路线导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.form.getFieldsValue()
      params.isStandardRoutingFlag = "N"
      this.download('bom/bomRoutingHeader/export_line', {
        ...params
      }, `产品工艺路线_${new Date().getTime()}.xlsx`)
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less"></style>
